<template>
  <div class="after_sales_reasons_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">售后记录</div>
        <div class="order_subtitle">客户财务统计</div>
      </div>
    </div>
    <div class="filter_content font">
      <span class="order_subtitle mb12">售后进度：</span>
      <el-select
        v-model="filterData.refundStatus"
        placeholder="请选择"
        class="mr12 mb12 width150"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="order_subtitle mb12">订单号：</span>
      <el-input
        v-model="filterData.orderNo"
        placeholder="请输入订单号"
        class="mr12 mb12 width200"
        size="small"
      ></el-input>
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        class="mb12"
        @click="getInfo(1)"
      >
        查询</el-button
      >
    </div>
    <div class="content_box">
      <div class="table_content">
        <el-table
          :data="tableData"
          style="width: 100%; max-width: 1200px"
          v-loading="loading"
        >
          <el-table-column prop="orderNo" label="订单号"> </el-table-column>
          <el-table-column prop="createTime" label="申请时间">
          </el-table-column>
          <el-table-column prop="refundDes" label="问题描述"> </el-table-column>
          <el-table-column prop="refundStatus" label="进度">
            <template slot-scope="scope">
              <div>
                {{
                  $enums.refundStatusEnum.getLabelByValue(
                    scope.row.refundStatus
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="replay" label="处理回复"> </el-table-column>
          <el-table-column prop="action" label="操作">
            <template slot-scope="scope">
              <div class="flex_center">
                <el-button
                  type="text"
                  class="mr12 price"
                  @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex_end statics" v-if="pageInfo.total > 10">
          <el-pagination
            :current-page.sync="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { refundListApi } from "../../api/index";
export default {
  data() {
    return {
      filterData: {
        timeDate: [],
        keywords: "",
        refundStatus: "",
      },
      tableData: [],
      currentPage1: 5,
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "VERIFY",
          label: "待处理",
        },
        {
          value: "VERIFYING",
          label: "处理中",
        },
        {
          value: "VERIFYED",
          label: "已处理",
        },
        {
          value: "REJECT",
          label: "驳回",
        },
        {
          value: "REFUSE",
          label: "拒绝处理",
        },
        {
          value: "FINISH",
          label: "处理完成",
        },
      ],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
    };
  },
  created() {
    this.getInfo();
  },
  activated() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    changePage(page) {
      this.pageInfo.pageNo = page;
      this.getInfo(this.pageInfo.pageNo);
    },
    getInfo(page = 1) {
      this.pageInfo.pageNo = page;
      if (this.loading) {
        return;
      }
      this.loading = true;
      refundListApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        refundStatus: this.filterData.refundStatus,
        orderNo: this.filterData.orderNo,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.tableData = res.resultData.refundList || [];
            this.pageInfo.total = res.resultData.totalNum || 0;
          } else {
            this.tableData = [];
            this.pageInfo.total = 0;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toDetail(data) {
      this.$router.push({
        name: "application_after",
        query: {
          refundId: data.refundId,
        },
      });
    },
  },
};
</script>

<style lang="less">
.after_sales_reasons_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  @media screen and (min-width: 480px) {
    .width150 {
      width: 150px;
    }
    .width200 {
      width: 200px;
    }
  }
  @media only screen and (max-width: 480px) {
    .width150 {
      width: 150px;
    }
    .width200 {
      width: 200px;
    }
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
}
.price {
  color: #00a0e9;
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>